// extracted by mini-css-extract-plugin
export default {"icon":"StripeAccountSetup_icon__Wp7pw","buttons":"StripeAccountSetup_buttons__sn0qU"};